var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#012169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L30 20M30 0L0 20",
    stroke: "#FFFFFF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V20M0 10H30",
    stroke: "#FFFFFF",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V20M0 10H30",
    stroke: "#C8102E",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L30 20M30 0L0 20",
    stroke: "#C8102E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.cfe9f12087ff147625ff36efa399cb30.svg";
export { ForwardRef as ReactComponent };